import {RequestUser} from '../resources/RequestUser';

/**
 * Base class for any event, that occurs within the FuPa ecosystem.
 */
export class DomainEvent<ResourceClass> {
  readonly event: string;
  readonly data: ResourceClass;
  /** timestamp in ISO-8601 format */
  readonly timestamp: string;
  /** optional, the user who caused or is otherwise related to the event */
  readonly principal?: RequestUser | undefined;
  /** optional, the number of times this event was tried to be processed */
  readonly attempt?: number;

  constructor(
    event: string,
    data: ResourceClass,
    timestamp?: Date | undefined,
    principal?: RequestUser | undefined,
    attempt?: number
  ) {
    this.event = event;
    this.data = data;
    this.timestamp = timestamp ? timestamp.toISOString() : new Date().toISOString();
    this.principal = principal;
    this.attempt = attempt;
  }
}
